<script setup>
import Button from 'primevue/button';
import { router, getNextRouteFromNewSigninState } from '@/helpers';
import { useAuthStore } from '@/stores';
import { useRoute } from 'vue-router';

const route = useRoute();
const authStore = useAuthStore();

const goBack = () => {
	authStore.signInState = 'init';
	router.push(getNextRouteFromNewSigninState(authStore.signInState, route));
};
</script>
<template>
	<div class="p-fluid login-small-form mb-8">
		<div class="mb-8">
			If we're able to locate your username, you'll receive an email with
			that information shortly.
		</div>
		<div class="cancel-button mb-8">
			<Button @click="goBack()" label="Back"></Button>
		</div>
	</div>
</template>
